import React, { useEffect, useCallback, useState} from 'react';
import {useMidiEffect} from './useMidiEffect.js';
import MidiEffectComponent from "components/effects/MidiEffectComponent.js";
import MiniTrackComponent from '../MiniTrackComponent.js';
import {addEffect} from 'scripting/commands/effects.js';
import {connect} from 'react-redux';

const EffectDoc = ({name, doc, sequencerEngine}) => { 
    const {effect, rack} = useMidiEffect({name, doc, sequencerEngine});
    return (
        <div className="effect-doc">
          <p className="sub-header">
            {name}
          </p>
          <p className="effect-description">
            {effect ?
             Array.isArray(effect.documentation) ?
             effect.documentation.map(x => <p>{x}</p>) :
             effect.documentation : ''}
          </p>
          <MiniTrackComponent sequencerEngine={sequencerEngine}/>
          <div className="effect-and-params">
          {effect ? <MidiEffectComponent
                      hideBarButtons={true}
                      sequencerEngine={sequencerEngine}
                      onDeleteEffect={() => []}
                      effect={rack || effect}
                      track={(rack || effect).track}
                    /> : ''}
            <div className="params">
              {effect && effect.parameters
               .filter(x => !x.hide)
               .filter(
                  x => Array.isArray(x.documentation) && x.documentation.length > 1)
               .map(x => <div className="param-doc"><b>{x.prettyName || x.name}</b>: {x.documentation[0]}</div>)}
            </div>
            <div className="extra-doc">
              {doc.component ? React.createElement(doc.component) : ''}
            </div>
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EffectDoc);
